"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var AccessKeySinkContext = /*#__PURE__*/(0, _react.createContext)();
var _default = AccessKeySinkContext;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9VdGlscy9BY2Nlc3NLZXlTaW5rL2ludGVybmFsL0NvbnRleHQuanMiXSwibmFtZXMiOlsiQWNjZXNzS2V5U2lua0NvbnRleHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFFQSxJQUFNQSxvQkFBb0IsZ0JBQUcsMkJBQTdCO2VBRWVBLG9CIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjcmVhdGVDb250ZXh0IH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBBY2Nlc3NLZXlTaW5rQ29udGV4dCA9IGNyZWF0ZUNvbnRleHQoKTtcblxuZXhwb3J0IGRlZmF1bHQgQWNjZXNzS2V5U2lua0NvbnRleHQ7XG4iXX0=